<template>
  <div>
    <v-data-iterator
      :no-data-text="noDataText"
      :items="dadosRelatorioOperador"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-spacer />
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="HeaderComPermissao"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          disable-sort
        >
          <template v-slot:[`header.centroDeCusto`]>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">C.C</div>
              </template>
              <span>Centro de Custo</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.centroDeCusto`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  {{ item.centroDeCusto }}
                </div>
              </template>
              <span>{{ item.centroDeCustoTooltip }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.tipo`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  {{ item.tipo }}
                </div>
              </template>
              <span>{{ item.tipoTooltip }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.botoes`]="{ item }">
            <v-row dense align="center" justify="center" class="text-center">
              <v-col
                cols="3"
                v-if="item.tipoChamada === 'Saida' && item.status !== 'Não Atendida' && permissaoOuvirLigacao"
              >
                <PlayerAudioSaida
                  :file="playerAudioSaida(item.linkedId)"
                  :archive="item.linkedId"
                  downloadable
                  color="primary"
                />
              </v-col>
              <v-col
                cols="3"
                v-if="item.tipoChamada !== 'Saida' && item.status !== 'Não Atendida' && permissaoOuvirLigacao"
              >
                <PlayerAudio
                  :file="playerAudioEntrada(item.record)"
                  :archive="item.record"
                  downloadable
                  color="primary"
                />
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Registros: {{ dadosRelatorioOperador.length }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import moment from 'moment'

import ListPagination from '@/componentes/ListPagination'
import { hostname } from '@/utils/hostname'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import PlayerAudio from '../../../../../components/PlayerAudio'
import PlayerAudioSaida from '../../../../../components/PlayerAudioSaida'

export default {
  name: 'TableInternaRelatorioDetalhado',
  props: {
    dadosRelatorioOperador: Array,
  },
  components: { PlayerAudio, PlayerAudioSaida, ListPagination },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    itemsPerPage: 20,
    moment: moment,
    page: 1,
    search: '',
    qtdRegistros: '',
    permissaoOuvirLigacao: false,
    arrayPermissaoOuvirLigacao: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_TOTAL,
      process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_OUVIR_GRAVACAO,
    ],
  }),

  computed: {
    numberOfPages() {
      return Math.ceil(this.dadosRelatorioOperador.length / this.itemsPerPage)
    },

    HeaderComPermissao(){
      if(this.permissaoOuvirLigacao){
          return  [
          { text: 'DataHora', value: 'dataHora', align: 'left' },
          { text: 'Origem', value: 'origem', align: 'left' },
          { text: 'Destino', value: 'destino', align: 'left' },
          { text: 'Centro de Custo', value: 'centroDeCusto', align: 'left' },
          { text: 'Tipo', value: 'tipo', align: 'left' },
          { text: 'Fila', value: 'fila', align: 'left' },
          { text: 'Status', value: 'status', align: 'left' },
          { text: 'Áudio', value: 'botoes', align: 'center', sortable: false },
          ]
      }else{
        return [
          { text: 'DataHora', value: 'dataHora', align: 'left' },
          { text: 'Origem', value: 'origem', align: 'left' },
          { text: 'Destino', value: 'destino', align: 'left' },
          { text: 'Centro de Custo', value: 'centroDeCusto', align: 'left' },
          { text: 'Tipo', value: 'tipo', align: 'left' },
          { text: 'Fila', value: 'fila', align: 'left' },
          { text: 'Status', value: 'status', align: 'left' },
          ]
      }
    }
  },

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.arrayPermissaoOuvirLigacao.includes(permissionLocalStorage)) {
        this.permissaoOuvirLigacao = true
      }
    })
  },

  methods: {
    ...obtainUserPermissions,

    playerAudioEntrada(audio) {
      return `https://${hostname()}/backend/asterisk/gravacao/fila/play/${audio}`
    },
    playerAudioSaida(audio) {
      return `https://${hostname()}/backend/asterisk/gravacao/player/${audio}`
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1
      }
    },
    firstPage() {
      if (this.page > 1) {
        this.page = 1
      }
    },
    lastPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.numberOfPages
      }
    },
  },
}
</script>
